import { Logger } from '@ori/logger';
import { PACKAGE_NAME, TEAM_NAME } from './constants-generated';
export const mainLogger = new Logger(PACKAGE_NAME, {
    teamName: TEAM_NAME
});
export const mypagesMainLogger = new Logger(PACKAGE_NAME, {
    part: 'mypages',
    teamName: TEAM_NAME
});
export const mypagesLogger = new Logger(PACKAGE_NAME, {
    part: 'mypages',
    teamName: TEAM_NAME
});
export const editorialsLogger = new Logger(PACKAGE_NAME, {
    part: 'editorials',
    teamName: TEAM_NAME
});
